module.exports = __webpack_public_path__ + "static/img/leftBottom.0cdc47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/leftBottom.png
// module id = rekm
// module chunks = 0